import { useParams } from 'react-router';

import { RouterEntitiesId } from '@clearverify/constants';

export const useUserPasswordChangeRequestIdParamId = () => {
  const { passwordChangeRequestId } = useParams<{
    [RouterEntitiesId.passwordChangeRequest]: string;
  }>();
  return passwordChangeRequestId;
};
